import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import NoHistoryView from "../jobcard-history/NoHistoryView";
import useGetHistory from "../../../../CustomHooks/useAxios/useGetHistory";
import CheckpointReportForm from "./CheckpointReportForm";
import { CheckpointResult } from "./CheckpointResult";
import { setData, setCopyData } from "../../../../redux/dataSlice";
import { ReportSummaryCards } from "./ReportSummaryCards";
import LoadingDisplay from "../../../../components/UI/LoadingDisplay";

const JobCardReportManager = ({ checkpointNames }) => {
  const dispatch = useDispatch();
  const historyError = useSelector((state) => state.data.error);
  const historyErrMsg = useSelector((state) => state.data.errMessage);
  const data = useSelector((state) => state.data.data);
  const copyData = useSelector((state) => state.data.copyData);
  const { getHistory, historyLoaded, isSucceed } = useGetHistory();

  useEffect(() => {
    if (isSucceed && !historyError) {
      dispatch(setData(data.items));
      dispatch(setCopyData(copyData.items));
    }
  }, [historyError, isSucceed]);

  return (
    <>
      <CheckpointReportForm
        checkpointNames={checkpointNames.checkpoints}
        getHistory={getHistory}
        historyError={historyError}
        historyErrMsg={historyErrMsg}
      />
      {historyLoaded ? (
        <LoadingDisplay height="h-[calc(100vh-11em)] lg:h-[calc(100vh-13em)] mt-2" />
      ) : isSucceed && copyData?.length > 0 ? (
        <>
          <ReportSummaryCards />
          <CheckpointResult />
        </>
      ) : (
        <NoHistoryView
          isSucceed={isSucceed}
          dataLength={copyData?.length}
          title="No date range Selected"
          description="Please select a date and checkpoint to view the report."
          filteredDescription="We couldn’t find any records for the selected date and checkpoint."
        />
      )}
    </>
  );
};

export default JobCardReportManager;
